/**
 * Subdomain helpers — single source of truth for the four Ashra surfaces.
 *
 * Frontend doesn't need to know prod URLs; it asks the backend via
 * `/api/auth/handoff` when it wants to send the user to another subdomain.
 * These constants are only used as fallbacks during local development.
 */

const RAW_BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const SURFACES = {
  marketing: process.env.REACT_APP_MARKETING_URL || "https://ashraai.com",
  app: process.env.REACT_APP_APP_URL || "https://app.ashraai.com",
  cx: process.env.REACT_APP_CX_URL || "https://cx.ashraai.com",
  admin: process.env.REACT_APP_ADMIN_URL || "https://admin.ashraai.com",
  api: RAW_BACKEND,
};

/**
 * Detect which subdomain surface this build is currently running on.
 * Falls back to "app" so creator features keep working in preview environments
 * that don't use real subdomains yet.
 */
export function currentSurface() {
  if (typeof window === "undefined") return "app";
  const host = window.location.host;
  if (host.startsWith("cx.")) return "cx";
  if (host.startsWith("app.")) return "app";
  if (host.startsWith("admin.")) return "admin";
  if (host === "ashraai.com" || host === "www.ashraai.com") return "marketing";
  return "app";  // preview / localhost default
}

export function urlFor(surface, path = "") {
  const base = (SURFACES[surface] || SURFACES.app).replace(/\/$/, "");
  return path ? `${base}/${String(path).replace(/^\//, "")}` : base;
}

/**
 * After a magic-link verify response we may receive `redirect_url` pointing
 * to another subdomain. If so, hand the user over by appending the JWT to
 * the URL so the destination can pick up the session.
 */
export function applyAuthRedirect(verifyResponse, fallbackPath = "/dashboard") {
  const target = verifyResponse?.redirect_url;
  const path = verifyResponse?.redirect_path || fallbackPath;
  if (!target) {
    window.location.replace(path);
    return;
  }
  try {
    const u = new URL(target);
    if (u.host === window.location.host) {
      window.location.replace(path);
    } else {
      window.location.assign(target);
    }
  } catch {
    window.location.replace(path);
  }
}
